import React, {useEffect, useMemo, useState} from 'react';
import {SparklesIcon, XMarkIcon} from '@heroicons/react/24/outline';

const AGENT_ID = 'tradly-mcp-curl-test-2026-10-25';
const CHAT_BASE_URL = 'https://aichat.tradly.app';

function encodeWidgetConfig(config) {
  return window.btoa(JSON.stringify(config))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export default function TradlyAssistantPanel() {
  const [open, setOpen] = useState(false);
  const config = useMemo(() => {
    if (typeof window === 'undefined') return '';
    return encodeWidgetConfig({
      agentUniqueId: AGENT_ID,
      autoOpen: true,
      hideLauncher: true,
    });
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = event => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open]);

  const chatUrl = config ? `${CHAT_BASE_URL}/widget/${config}` : '';

  return (
    <>
      <button
        type="button"
        aria-label="Ask AI"
        aria-expanded={open}
        aria-controls="tradly-ai-side-panel"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 rounded-md border px-3 py-2 text-sm font-medium"
        style={{color: 'var(--sidebar-text)', borderColor: 'var(--color-border, rgba(255,255,255,.2))'}}>
        <SparklesIcon style={{width: 18, height: 18}} />
        <span>Ask AI</span>
      </button>

      {open && (
        <>
          <button
            type="button"
            aria-label="Close AI assistant panel"
            onClick={() => setOpen(false)}
            className="fixed inset-0 z-[10000] bg-black/30"
          />
          <aside
            id="tradly-ai-side-panel"
            role="dialog"
            aria-modal="true"
            aria-label="Tradly AI Assistant"
            className="fixed inset-y-0 right-0 z-[10001] flex w-full flex-col bg-white shadow-2xl md:w-[460px]"
            style={{borderLeft: '1px solid var(--color-border, #e5e7eb)'}}>
            <div className="flex h-14 shrink-0 items-center justify-between border-b px-4">
              <div className="flex items-center gap-2 font-medium text-gray-900">
                <SparklesIcon style={{width: 20, height: 20, color: '#4f46e5'}} />
                Tradly AI Assistant
              </div>
              <button
                type="button"
                aria-label="Close AI assistant"
                onClick={() => setOpen(false)}
                className="rounded-md p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-900">
                <XMarkIcon style={{width: 20, height: 20}} />
              </button>
            </div>
            <iframe
              title="Tradly AI Assistant chat"
              src={chatUrl}
              className="min-h-0 flex-1 border-0"
              allow="clipboard-write"
            />
          </aside>
        </>
      )}
    </>
  );
}
